<div class="login-body">

  <div class="flex-row tw:h-screen" id="login">
    <div class="flex-column"></div>
    <div class="flex-column-main">

      <div class="content-wrapper">

        <app-login-brand></app-login-brand>

        <div class="login-card">
        @if (!showResetPinPanel) {
          <div>
            <div class="form-group" [ngClass]="{ 'has-error': showFirstNameRequired }">
              <input type="text" class="form-control" placeholder="Enter your first name" name="firstName"
                [(ngModel)]="firstName" required />
                @if (showFirstNameRequired) {
                  <div>First name is required</div>
                }
              </div>
              <div class="form-group" [ngClass]="{ 'has-error': showBirthMonthRequired }">
                <select [(ngModel)]="birthMonth" class="form-control" aria-placeholder="Birth Month">
                  <option value="" disabled selected>Select the month of your birthday</option>
                  <option value="January">January</option>
                  <option value="February">February</option>
                  <option value="March">March</option>
                  <option value="April">April</option>
                  <option value="May">May</option>
                  <option value="June">June</option>
                  <option value="July">July</option>
                  <option value="August">August</option>
                  <option value="September">September</option>
                  <option value="October">October</option>
                  <option value="November">November</option>
                  <option value="December">December</option>
                </select>
                @if (showBirthMonthRequired) {
                  <div>Birth month is required</div>
                }
              </div>
              @if (!isGuidLogin) {
                <div class="btn-group tw:w-full">
                  <button class="btn-outline-light btn-lg tw:mb-6 show-emoji-button"
                    [ngClass]="{'pin-selector-active': showEmojis}" type="button"
                  (click)="showEmojiPanel()">Emojis</button>
                  <button class="btn-outline-light btn-lg tw:mb-6 show-numbers-button"
                    [ngClass]="{'pin-selector-active': showNumbers}" type="button"
                  (click)="showNumberPanel()">Pin</button>
                </div>
              }
              @if (!isGuidLogin && (showEmojis || showNumbers)) {
                <div class="form-group"
                  [ngClass]="{ 'has-error': showPinRequired }">
                  <div class="tw:flex tw:flex-wrap tw:p-0 tw:m-0 tw:mb-4">
                    <div class="tw:w-full tw:md:w-auto tw:md:flex-1 tw:p-0 tw:m-0 tw:mr-1 tw:flex tw:justify-center">
                      <div #pin1 class="pin-box tw:md:float-left tw:inline-block tw:mx-1"
                      [ngClass]="{'tw:pt-4': isNumericPin, 'pin-box-emoji': !isNumericPin}"></div>
                      <div #pin2 class="pin-box tw:md:float-left tw:inline-block tw:mx-1"
                      [ngClass]="{'tw:pt-4': isNumericPin, 'pin-box-emoji': !isNumericPin}"></div>
                      <div #pin3 class="pin-box tw:md:float-left tw:inline-block tw:mx-1"
                      [ngClass]="{'tw:pt-4': isNumericPin, 'pin-box-emoji': !isNumericPin}"></div>
                      <div #pin4 class="pin-box tw:md:float-left tw:inline-block tw:mx-1"
                      [ngClass]="{'tw:pt-4': isNumericPin, 'pin-box-emoji': !isNumericPin}"></div>
                    </div>
                    <div class="tw:w-full tw:md:w-auto tw:md:flex-1 tw:p-0 tw:m-0 tw:pt-6 tw:md:pt-0" style="width: 140px;">
                      <button class="btn-outline-light btn-lg btn-clear-pin tw:ml-1" type="button"
                      (click)="clearPin()">Clear</button>
                    </div>
                  </div>
                  @if (showPinRequired) {
                    <div class="text-dander">Pin is required</div>
                  }
                </div>
              }
              @if (showEmojis) {
                <div class="form-group">
                  <div class="emoji-pad tw:mt-4 tw:mx-auto tw:text-center" role="group" aria-label="Emoji pad">
                    <div class="tw:flex tw:flex-wrap emoji-pad-row tw:p-0 tw:m-0">
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon smile-emoji" (click)="emojiSelected('smile')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon ghost-emoji" (click)="emojiSelected('ghost')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon wave-emoji" (click)="emojiSelected('wave')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon glasses-emoji" (click)="emojiSelected('glasses')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon crown-emoji" (click)="emojiSelected('crown')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon zebra-emoji" (click)="emojiSelected('zebra')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon cat-emoji" (click)="emojiSelected('cat')"></p>
                      </div>
                    </div>
                    <div class="tw:flex tw:flex-wrap emoji-pad-row tw:p-0 tw:m-0">
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon sunflower-emoji" (click)="emojiSelected('sunflower')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon rocket-emoji" (click)="emojiSelected('rocket')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon car-emoji" (click)="emojiSelected('car')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon lightning-emoji" (click)="emojiSelected('lightning')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon bulb-emoji" (click)="emojiSelected('bulb')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon alien-emoji" (click)="emojiSelected('alien')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon heart-emoji" (click)="emojiSelected('heart')"></p>
                      </div>
                    </div>
                    <div class="tw:flex tw:flex-wrap emoji-pad-row tw:p-0 tw:m-0">
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon trophy-emoji" (click)="emojiSelected('trophy')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon football-emoji" (click)="emojiSelected('football')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon eightball-emoji" (click)="emojiSelected('eightball')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon dice-emoji" (click)="emojiSelected('dice')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon house-emoji" (click)="emojiSelected('house')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon tree-emoji" (click)="emojiSelected('tree')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon pineapple-emoji" (click)="emojiSelected('pineapple')"></p>
                      </div>
                    </div>
                    <div class="tw:flex tw:flex-wrap emoji-pad-row tw:p-0 tw:m-0">
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon thumbs-up-emoji" (click)="emojiSelected('thumbs-up')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon fish-emoji" (click)="emojiSelected('fish')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon present-emoji" (click)="emojiSelected('present')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon laugh-emoji" (click)="emojiSelected('laugh')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon sleep-emoji" (click)="emojiSelected('sleep')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon coffee-emoji" (click)="emojiSelected('coffee')"></p>
                      </div>
                      <div class="tw:flex-1 emoji-pad-col tw:p-0 tw:m-0">
                        <p class="btn-emoji-pad-icon earth-emoji" (click)="emojiSelected('earth')"></p>
                      </div>
                    </div>
                  </div>
                </div>
              }
              @if (showNumbers) {
                <div class="form-group">
                  <div class="number-pad tw:mt-4 tw:mx-auto" role="group" aria-label="Number pad">
                    <div class="tw:flex tw:flex-wrap number-pad-row tw:p-0 tw:m-0">
                      <div class="tw:flex-1 number-pad-col tw:p-0 tw:m-0">
                        <button type="button" class="btn btn-number-pad-digit tw:py-6 tw:w-full tw:h-full"
                        (click)="numberSelected('1')">1</button>
                      </div>
                      <div class="tw:flex-1 number-pad-col tw:p-0 tw:m-0">
                        <button type="button" class="btn btn-number-pad-digit tw:py-6 tw:w-full tw:h-full"
                        (click)="numberSelected('2')">2</button>
                      </div>
                      <div class="tw:flex-1 number-pad-col tw:p-0 tw:m-0">
                        <button type="button" class="btn btn-number-pad-digit tw:py-6 tw:w-full tw:h-full"
                        (click)="numberSelected('3')">3</button>
                      </div>
                    </div>
                    <div class="tw:flex tw:flex-wrap number-pad-row tw:p-0 tw:m-0">
                      <div class="tw:flex-1 number-pad-col tw:p-0 tw:m-0">
                        <button type="button" class="btn btn-number-pad-digit tw:py-6 tw:w-full tw:h-full"
                        (click)="numberSelected('4')">4</button>
                      </div>
                      <div class="tw:flex-1 number-pad-col tw:p-0 tw:m-0">
                        <button type="button" class="btn btn-number-pad-digit tw:py-6 tw:w-full tw:h-full"
                        (click)="numberSelected('5')">5</button>
                      </div>
                      <div class="tw:flex-1 number-pad-col tw:p-0 tw:m-0">
                        <button type="button" class="btn btn-number-pad-digit tw:py-6 tw:w-full tw:h-full"
                        (click)="numberSelected('6')">6</button>
                      </div>
                    </div>
                    <div class="tw:flex tw:flex-wrap number-pad-row tw:p-0 tw:m-0">
                      <div class="tw:flex-1 number-pad-col tw:p-0 tw:m-0">
                        <button type="button" class="btn btn-number-pad-digit tw:py-6 tw:w-full tw:h-full"
                        (click)="numberSelected('7')">7</button>
                      </div>
                      <div class="tw:flex-1 number-pad-col tw:p-0 tw:m-0">
                        <button type="button" class="btn btn-number-pad-digit tw:py-6 tw:w-full tw:h-full"
                        (click)="numberSelected('8')">8</button>
                      </div>
                      <div class="tw:flex-1 number-pad-col tw:p-0 tw:m-0">
                        <button type="button" class="btn btn-number-pad-digit tw:py-6 tw:w-full tw:h-full"
                        (click)="numberSelected('9')">9</button>
                      </div>
                    </div>
                    <div class="tw:flex tw:flex-wrap number-pad-row tw:p-0 tw:m-0">
                      <div class="tw:flex-1 number-pad-col tw:p-0 tw:m-0">
                        <button type="button" class="btn btn-number-pad-digit tw:py-6 tw:w-full tw:h-full"
                        (click)="numberSelectBackspace()">&lt;</button>
                      </div>
                      <div class="tw:flex-1 number-pad-col tw:p-0 tw:m-0">
                        <button type="button" class="btn btn-number-pad-digit tw:py-6 tw:w-full tw:h-full"
                        (click)="numberSelected('0')">0</button>
                      </div>
                      <div class="tw:flex-1 number-pad-col tw:p-0 tw:m-0">
                      </div>
                    </div>
                  </div>
                </div>
              }
              <div class="form-group">
                <button [disabled]="loading" class="btn-outline-light btn-lg login-submit full-width-button" type="button"
                (click)="login()">Sign In</button>
              </div>
              <div class="form-group tw:text-center">
                <!--  *ngIf="themeService.siteContent.enableStudentEmailing == 'true'" -->
                <label class="forgot-password-link" (click)="showResetPinPanel = true">
                  Forgotten or reset password
                </label>
              </div>
            </div>
          }
          @if (showResetPinPanel) {
            <div>
              <div class="form-group" [ngClass]="{ 'has-error': showEmailAddressRequired }">
                <input type="text" class="form-control" placeholder="Enter your email address" name="emailAddress"
                  [(ngModel)]="emailAddress" required />
                  @if (showEmailAddressRequired) {
                    <div>Email address is required</div>
                  }
                </div>
                <div class="btn-group tw:w-full">
                  <button class="btn-outline-light btn-lg tw:mb-6 show-emoji-button" type="button"
                  (click)="showResetPinPanel = false">Cancel</button>
                  <button class="btn-outline-light btn-lg tw:mb-6 show-numbers-button" type="button"
                  (click)="submitRestPin()">Submit</button>
                </div>
              </div>
            }

        </div>

      </div>

    </div>
    <div class="flex-column"></div>
  </div>
</div>